// extracted by mini-css-extract-plugin
export default {"modalTitle":"DisableModal_modalTitle__9cPOC","icon":"DisableModal_icon__vP3+x","modalContent":"DisableModal_modalContent__ptBA3","modalFoot":"DisableModal_modalFoot__2C47X"};